"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OtiIntegrationSnowplow = void 0;
var cookies_category_model_1 = require("../model/cookies-category.model");
var OtiIntegrationSnowplow = /** @class */ (function () {
    function OtiIntegrationSnowplow(cookiePreferenceChange$, userChange$, logService) {
        var _this = this;
        this.cookiePreferenceChange$ = cookiePreferenceChange$;
        this.userChange$ = userChange$;
        this.logService = logService;
        this.snowplowTackerId = 'cf';
        this.isTrackerInitialized = false;
        this.isTrackingEnabled = false;
        this.initTimeout = null;
        this.untrackedPageViewEvents = [];
        this.untrackedStructEvents = [];
        this.snowplowEnabled = false;
        this.snowplowLibUrl = OtiIntegrationSnowplow.SnowplowLibraryUrl;
        this.snowplowLibVersion = OtiIntegrationSnowplow.SnowplowLibraryVersion;
        this.userChange$.subscribe(function (user) {
            _this.setUserId(user === null || user === void 0 ? void 0 : user.userId);
        });
    }
    OtiIntegrationSnowplow.prototype._addSnowplowGlobalContextsToTracker = function (context) {
        window.snowplow('clearGlobalContexts', [this.snowplowTackerId]);
        window.snowplow('addGlobalContexts', [JSON.parse(JSON.stringify(context))], [this.snowplowTackerId]);
    };
    OtiIntegrationSnowplow.prototype._clearUntrackedEvents = function () {
        this.untrackedPageViewEvents = [];
        this.untrackedStructEvents = [];
    };
    OtiIntegrationSnowplow.prototype._determineSnowplowCollectorUrl = function (options, isOnProduction) {
        return options.snowplow_url || (isOnProduction ? OtiIntegrationSnowplow.SnowplowDefaultProdCollectorUrl : OtiIntegrationSnowplow.SnowplowDefaultDevCollectorUrl);
    };
    OtiIntegrationSnowplow.prototype._digestUntrackedEvents = function () {
        var _this = this;
        if (this.isTrackingEnabled) {
            this.untrackedPageViewEvents.forEach(function (evt) { return _this._trackSnowplowPageViewEvent(evt); });
            this.untrackedStructEvents.forEach(function (evt) { return _this._trackSnowplowStructEvent(evt); });
            this._clearUntrackedEvents();
        }
    };
    OtiIntegrationSnowplow.prototype._disableTrackingPlugins = function () {
        // Disable tracking plugins
    };
    OtiIntegrationSnowplow.prototype._enableTrackingPlugins = function () {
        // Enable tracking plugins
    };
    OtiIntegrationSnowplow.prototype._getSnowplowLibraryUrl = function () {
        var spPath = this.snowplowLibUrl.replace(/\/$/, '');
        var spFile = "sp-".concat(this.snowplowLibVersion, ".js");
        return "".concat(spPath, "/").concat(spFile);
    };
    OtiIntegrationSnowplow.prototype._initializeTracker = function () {
        var config = {
            anonymousTracking: !this.snowplowUserId,
            appId: this.appId,
            contexts: {
                webPage: true,
                session: false,
                performanceTiming: true,
                gaCookies: true
            },
            cookieSameSite: 'Lax',
            discoverRootDomain: true,
            encodeBase64: false,
            eventMethod: this.snowplowEventMethod,
            platform: 'web',
            withCredentials: false,
        };
        window.snowplow('newTracker', this.snowplowTackerId, this.snowplowCollectorUrl, config);
        this.isTrackerInitialized = true;
        this.logService.log("Snowplow tracker #".concat(this.snowplowTackerId, " initialized"), config);
        if (this.snowplowUserId) {
            window.snowplow('setUserId', this.snowplowUserId);
        }
        if (this.snowplowContext) {
            this._addSnowplowGlobalContextsToTracker(this.snowplowContext);
        }
    };
    OtiIntegrationSnowplow.prototype._loadSnowplow = function () {
        var _a;
        if (!window.snowplow) {
            window.GlobalSnowplowNamespace = window.GlobalSnowplowNamespace || [];
            window.GlobalSnowplowNamespace.push('snowplow');
            window.snowplow = (function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                (window.snowplow.q = window.snowplow.q || []).push(args);
            });
            window.snowplow.q = window.snowplow.q || [];
            var scriptEl = document.createElement('script');
            var firstScriptEl = document.getElementsByTagName('script')[0];
            if (firstScriptEl) {
                scriptEl.async = true;
                scriptEl.src = this._getSnowplowLibraryUrl();
                (_a = firstScriptEl.parentNode) === null || _a === void 0 ? void 0 : _a.insertBefore(scriptEl, firstScriptEl);
                this.logService.log("Load snowplow library ".concat(scriptEl.src));
            }
        }
    };
    OtiIntegrationSnowplow.prototype._notifyInitialCookieSettingsDelayed = function (nextActiveGroups) {
        var _this = this;
        if (this.initTimeout) {
            clearTimeout(this.initTimeout.timeout);
            var promise_1;
            return promise_1 = new Promise(function (resolve, reject) {
                _this.initTimeout = {
                    promise: promise_1,
                    nextActiveGroups: nextActiveGroups,
                    timeout: window.setTimeout(function () {
                        if (_this.initTimeout) {
                            _this._notifyCookieSettings(_this.initTimeout.nextActiveGroups).then(resolve).catch(reject);
                            _this.initTimeout = null;
                        }
                        else {
                            reject(new Error('Notify timeout break unexpectedly'));
                        }
                    }, 1000),
                    reject: reject
                };
            });
        }
        else {
            var promise_2;
            return promise_2 = new Promise(function (resolve, reject) {
                _this.initTimeout = {
                    promise: promise_2,
                    nextActiveGroups: nextActiveGroups,
                    timeout: window.setTimeout(function () {
                        if (_this.initTimeout) {
                            _this._notifyCookieSettings(_this.initTimeout.nextActiveGroups).then(resolve).catch(reject);
                            _this.initTimeout = null;
                        }
                        else {
                            reject(new Error('Notify timeout break unexpectedly'));
                        }
                    }, 1000),
                    reject: reject
                };
            });
        }
    };
    OtiIntegrationSnowplow.prototype._notifyCookieSettings = function (nextActiveGroups) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.isTrackingEnabled = nextActiveGroups.indexOf(OtiIntegrationSnowplow.SnowplowCookieCategory) >= 0;
                this.logService.log('Snowplow. CookiesPreference Set as targetingCookieValue=' + this.isTrackingEnabled);
                if (this.isTrackingEnabled) {
                    if (this.isTrackerInitialized) {
                        this._enableTrackingPlugins();
                    }
                    else {
                        this._initializeTracker();
                    }
                    this._digestUntrackedEvents();
                }
                else if (this.isTrackerInitialized) {
                    this._disableTrackingPlugins();
                }
                return [2 /*return*/];
            });
        });
    };
    OtiIntegrationSnowplow.prototype._notifyUpdateCookieSettings = function (nextActiveGroups, prevActiveGroups) {
        return __awaiter(this, void 0, void 0, function () {
            var prvTargetingCookieValue, nxtTargetingCookieValue, TargetingCategoryChanged;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        prvTargetingCookieValue = prevActiveGroups.indexOf(OtiIntegrationSnowplow.SnowplowCookieCategory) === -1 ? 'NO' : 'YES';
                        nxtTargetingCookieValue = nextActiveGroups.indexOf(OtiIntegrationSnowplow.SnowplowCookieCategory) === -1 ? 'NO' : 'YES';
                        TargetingCategoryChanged = prvTargetingCookieValue != nxtTargetingCookieValue;
                        this.logService.log('Snowplow. CookiesPreference Update' +
                            ' targetingCookieValue=' +
                            nxtTargetingCookieValue +
                            (TargetingCategoryChanged ? ', targeting' : ''));
                        if (!TargetingCategoryChanged) return [3 /*break*/, 2];
                        return [4 /*yield*/, this._notifyCookieSettings(nextActiveGroups)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    OtiIntegrationSnowplow.prototype._storeSnowplowStructEvent = function (evt) {
        this.logService.log('storeStructEvent', evt);
        this.untrackedStructEvents.push(__assign({ timestamp: new Date().getTime() }, evt));
    };
    OtiIntegrationSnowplow.prototype._storeSnowplowPageViewEvent = function (evt) {
        this.logService.log('storePageViewEvent', evt);
        this.untrackedPageViewEvents.push(__assign({ timestamp: new Date().getTime() }, evt));
    };
    OtiIntegrationSnowplow.prototype._trackSnowplowStructEvent = function (evt) {
        this.logService.log('trackStructEvent', evt);
        window.snowplow('trackStructEvent', evt.category, evt.action, evt.label, evt.property, evt.value, undefined, evt.timestamp);
    };
    OtiIntegrationSnowplow.prototype._trackSnowplowPageViewEvent = function (evt) {
        this.logService.log('trackPageView', evt);
        window.snowplow('trackPageView', (evt === null || evt === void 0 ? void 0 : evt.pageUrl) || window.location.pathname, evt === null || evt === void 0 ? void 0 : evt.pageTitle, evt === null || evt === void 0 ? void 0 : evt.referrer, undefined, evt === null || evt === void 0 ? void 0 : evt.timestamp);
    };
    OtiIntegrationSnowplow.prototype.configure = function (_a) {
        var options = _a.options, isOnProduction = _a.isOnProduction;
        this.isOneTrustEnabled = !!options.ot_key;
        this.appId = options.app_id;
        this.snowplowCollectorUrl = this._determineSnowplowCollectorUrl(options, isOnProduction);
        this.snowplowLibUrl = OtiIntegrationSnowplow.SnowplowLibraryUrl;
        this.snowplowLibVersion = OtiIntegrationSnowplow.SnowplowLibraryVersion;
        this.snowplowEnabled = options.snowplow_enabled === true || options.snowplow_enabled === undefined && options.snowplow_session_id !== undefined;
        this.snowplowSessionId = options.snowplow_session_id;
        this.snowplowUserId = options.user_id;
        this.snowplowEventMethod = options.snowplow_event_method || 'post';
        this.snowplowContext = {
            schema: OtiIntegrationSnowplow.SnowplowDefaultIgluSchema,
            data: options.snowplow_context_data || {
                appsessionId: this.snowplowSessionId,
                product: this.appId,
            },
        };
    };
    OtiIntegrationSnowplow.prototype.init = function () {
        var _this = this;
        this._loadSnowplow();
        if (this.isOneTrustEnabled) {
            this.cookiePreferenceChange$.subscribe(function (_a) {
                var initial = _a.initial, next = _a.next, prev = _a.prev;
                return _this.notifyCookieSettings(initial, next, prev);
            });
        }
        else {
            this.isTrackingEnabled = true;
            this._initializeTracker();
        }
    };
    OtiIntegrationSnowplow.prototype.enabled = function () {
        return this.snowplowEnabled;
    };
    OtiIntegrationSnowplow.prototype.notifyCookieSettings = function (optanonInitiallyLoad, nextActiveGroups, prevActiveGroups) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!optanonInitiallyLoad) return [3 /*break*/, 4];
                        if (!!nextActiveGroups) return [3 /*break*/, 1];
                        this.logService.log('Snowplow. Missing CookiesPreference');
                        return [3 /*break*/, 3];
                    case 1: return [4 /*yield*/, this._notifyInitialCookieSettingsDelayed(nextActiveGroups)];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [3 /*break*/, 7];
                    case 4:
                        if (!(!nextActiveGroups || !prevActiveGroups)) return [3 /*break*/, 5];
                        this.logService.log('Snowplow. Missing CookiesPreference');
                        return [3 /*break*/, 7];
                    case 5: return [4 /*yield*/, this._notifyUpdateCookieSettings(nextActiveGroups, prevActiveGroups)];
                    case 6:
                        _a.sent();
                        _a.label = 7;
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    OtiIntegrationSnowplow.prototype.resetContext = function (context) {
        this.snowplowContext = context;
        this._addSnowplowGlobalContextsToTracker(context);
    };
    OtiIntegrationSnowplow.prototype.updateContextData = function (contextData) {
        if (this.snowplowContext) {
            this.snowplowContext.data = __assign(__assign({}, this.snowplowContext.data), contextData);
            this._addSnowplowGlobalContextsToTracker(this.snowplowContext);
        }
        else {
            console.warn('a valid context is needed for update');
        }
    };
    OtiIntegrationSnowplow.prototype.setUserId = function (userId) {
        if (this.snowplowUserId !== userId) {
            this.snowplowUserId = userId;
            this._clearUntrackedEvents();
            this.logService.log('Snowplow. SetUserId', this.snowplowUserId);
            if (this.snowplowUserId) {
                window.snowplow('setUserId', this.snowplowUserId);
                window.snowplow('disableAnonymousTracking');
            }
            else {
                window.snowplow('enableAnonymousTracking');
            }
        }
    };
    OtiIntegrationSnowplow.prototype.trackSnowplowStructEvent = function (evt) {
        if (this.isTrackingEnabled) {
            this._trackSnowplowStructEvent(evt);
        }
        else {
            this._storeSnowplowStructEvent(evt);
        }
    };
    OtiIntegrationSnowplow.prototype.trackSnowplowPageView = function (evt) {
        if (this.isTrackingEnabled) {
            this._trackSnowplowPageViewEvent(evt);
        }
        else {
            this._storeSnowplowPageViewEvent(evt);
        }
    };
    OtiIntegrationSnowplow.SnowplowCookieCategory = cookies_category_model_1.CookiesCategory.FUNCTIONAL;
    OtiIntegrationSnowplow.SnowplowDefaultDevCollectorUrl = 'snowplow-collector.staging.userintel.dev.sp.aws.clarivate.net';
    OtiIntegrationSnowplow.SnowplowDefaultProdCollectorUrl = 'snowplow-collector.userintel.prod.sp.aws.clarivate.net';
    OtiIntegrationSnowplow.SnowplowDefaultIgluSchema = 'iglu:ne.clarivate.com/usage/jsonschema/2-0-0';
    OtiIntegrationSnowplow.SnowplowLibraryUrl = '//d3rm6si6l6yzgk.cloudfront.net/webui/sp';
    OtiIntegrationSnowplow.SnowplowLibraryVersion = '2.16.3';
    return OtiIntegrationSnowplow;
}());
exports.OtiIntegrationSnowplow = OtiIntegrationSnowplow;
